import {uuid} from "../helpers/uuid";

export const paymentInitializationType = {
  type: '',
  amount: 0,
  replacementDiscount: 0,
};

export default class Payment {
  constructor(initObject = paymentInitializationType) {
    this.key = uuid();
    this.type = initObject.type;
    this.amount = initObject.amount;
    this.replacementDiscount = initObject.replacementDiscount;
  }
}
